<template>
	<div style="width: 100%; height: 100%; position: fixed; top: 0px; left: 0px; background: rgba(0, 0, 0, 0.5); z-index: 10555; display: flex; flex-direction: column; align-items: center; justify-content: center;">
		<div 
			ref="floatButton"
			class="float-info"
			>
			<div style="flex: 1; display: flex; width: 100%;">
				<div style="width: 100%; height: calc(100vh - 40px); position: relative; display: flex; flex-direction: column; overflow: hidden; border-radius: 20px;">
					
					<img style="position: absolute; width: 100%; height: 370px; left: 0px; top: 0px; z-index: 0;" src="../../assets/icon_home_ai_icon_0.png" alt="" draggable="false" />
					
					<div class="markdownContent" @mouseenter="mouseenter" @mouseleave="mouseleave" id="contentScrollId" :class="['tca', 'hiddenScrollbar']" style="display: block; flex-direction: column; align-self: flex-start; padding-left: 20px; padding-right: 20px; overflow: scroll; width: 100%; padding-bottom: 2px; z-index: 1;" :style="{ height: (clientHeight - 105 - 40) + 'px'}" draggable="false">
						
						<div v-for="(item, index) in msgArr" style="display: flex; flex-direction: column;">
							<div v-if="item.type == 'start1'" style="border-radius: 2px 12px 12px 12px; background: rgba(93, 124, 248, 0.20); display: flex; flex-direction: column; padding-left: 20px; padding-right: 20px; padding-bottom: 20px; width: 392px;">
								<!-- <img style="width: 60px; height: 60px; margin-top: 10px; margin-left: -5px;" draggable="false" src="../../../../assets/icon_home_ai_logo_2.gif" alt="" /> -->
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: rgba(160, 208, 231, 1); line-height: 22px;">Hi～，我是清雷AI助手，很乐意为你提高工作效率</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(160, 208, 231, 0.6); line-height: 20px; margin-top: 5px;">试试以下指令吧：</div>
								<div style="background: linear-gradient( 45deg, rgba(39, 255, 247, 0.5) 0%, rgba(59,178,251,0.2) 51%, rgba(78, 106, 255, 0.5) 100%); border-radius: 20px 20px 20px 2px; display: flex; align-items: center; padding: 10px; align-self: flex-start; margin-top: 10px; cursor: pointer;" @click="clickAiAnalysis(null)">
									<div style="width: 10px; height: 10px; border: 2px solid #FFFFFF; border-radius: 5px; margin-right: 5px;"></div>
									<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #FFFFFF; line-height: 20px;">帮我解读“院内长者报告”</div>
								</div>
							</div>
							<div v-else-if="item.type == 'analysis'" style="display: flex; justify-content: flex-end;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: rgba(31, 38, 53, 1); line-height: 22px; padding: 20px; background: rgba(73, 122, 229, 0.2); border-radius: 12px 2px 12px 12px; margin-top: 15px; align-self: flex-end; min-width: 391px;">{{ item.title || '' }}</div>
							</div>
							<div v-else-if="item.type == 'aiContent'" style="display: flex;">
								<AiHoverBtnCard2 ref="aiHoverBtnCard2RefReport"  :sourceType="'AiReport'" :data="item" :dataIndex="index" :msgArr="msgArr" :modelValue.sync="sessionId" :shareTitle="shareTitle" :shareSubTitle="shareSubTitle" @changeMsgArr="changeMsgArr" @clickAiAnalysis="clickAiAnalysis" @changeShareTitle="changeShareTitle" @changeShareSubTitle="changeShareSubTitle" @requestFinish="requestFinish" @typewritingFinish="typewritingFinish"/>
							</div>
						</div>

						<!-- <div v-if="isLoading" style="display: flex; height: 120px; background: rgba(93, 124, 248, 0.20); border-radius: 2px 12px 12px 12px; margin-top: 15px; overflow: hidden;" v-loading="isLoading" element-loading-text="AI分析中，请稍候..." class="loadingContent"></div> -->
					</div>

					<div style="flex: 1;"></div>

					<div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
						<div :class="['my-el-input-ai-report-container', isEditing || (searchText && searchText.length > 0) || aiIsRequest ? 'my-el-input-ai-report-container-editing' : '']">
							<!-- <el-input
								:class="'my-el-input-ai-report', isEditing  || (searchText && searchText.length > 0) || aiIsRequest ? 'my-el-input-ai-report-editing' : ''"
								v-model="searchText"
								:autosize="{ minRows: 0, maxRows: 12 }"
								type="textarea"
								placeholder="输入你的问题，帮你深度解答"
								:show-word-limit="false"
								:resize="'none'"
								@focus="handleFocus" @blur="handleBlur" @keyup.enter="removeFocus" readonly onfocus="this.removeAttribute('readonly');"
							/> -->
							
							<textarea
								class="deepseek-textarea"
								v-model="searchText"
								@input="adjustHeight"
								@keydown.enter.exact.prevent="sendMessage"
								@keydown.shift.enter.prevent="newLine"
								@focus="handleFocus"
								@blur="handleBlur"
								placeholder="输入你的问题，帮你深度解答"
								ref="deepseekTextareaRef"
							>
							</textarea>


							
							<div :class="['search-btn', searchText && searchText.length > 0 ? 'search-btn-can-search' : '', aiIsRequest ? 'search-btn-searching' : '']" @click="clickAiSearch"></div>
						</div>
					</div>
					<div style="display: flex; justify-content: center; align-items: center; margin-bottom: 20px; margin-top: 10px;">
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 0.6); line-height: 20px;">内容由 AI 大模型生成，请仔细甄别</div>
					</div>
				</div>
			</div>
			<div v-if="toastStr" style="position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 8px; backdrop-filter: blur(8px); padding: 15px; display: flex; justify-content: center; align-items: center;">
				<!-- <img style="width: 16px; height: 16px; margin-right: 5px;" src="../../../../assets/icon_home_ai_icon_10.png" alt="" draggable="false" /> -->
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #FFFFFF; line-height: 22px;">{{ toastStr }}</div>
			</div>
			<div style="position: absolute; right: -56px; top: 0px;" @click="clickCloseAiReport">
				 <img style="width: 36px; height: 36px; margin-right: 5px;" src="../../assets/icon_ai_report_icon_close_1.png" alt="" />
			</div>
		</div>
	</div>
</template>
  
<script>

import {marked} from 'marked'
// import {QRCode} from "qrcodejs2";
// import QRCode from 'qrcodejs2'
import QRCode from "qrcodejs2";
import axios from 'axios';
import AiHoverBtnCard2 from "./aiHoverBtnCard2.vue"

const sleep = async (time) => {
    return new Promise((res) => {
        setTimeout(() => {
            res(true);
        }, time);
    });
};
const markdown = '';
const parseToken = (token) => {
    const whitelist = ['link', 'image', 'video'];
    if (token.type.indexOf(whitelist) < 0 && (token.tokens && token.tokens.length > 0 || token.items && token.items.length > 0)) {
        let pre, hz = "";
        if (token.text) {
            let zz = token.raw.split(token.text);
            if (zz && zz.length > 1) {
                pre = zz && zz[0] ? zz[0] : "";
                hz = zz && zz[1] ? zz[1] : "";
            }
        }
        let tks = [];
		if (token.items && token.items.length > 0) {
			for (let index = 0; index < token.items.length; index++) {
				const tk = token.items[index];
				const itemtks = parseToken(tk);
				if (pre || hz) {
					tks.push({
						pre,
						hz,
						itemtks
					});
				} else {
					tks = tks.concat(itemtks);
				}
			}
		} else {
			for (let index = 0; index < token.tokens.length; index++) {
				const tk = token.tokens[index];
				const itemtks = parseToken(tk);
				if (pre || hz) {
					tks.push({
						pre,
						hz,
						itemtks
					});
				} else {
					tks = tks.concat(itemtks);
				}
			}
		}
        return tks;
    }
    if (token.type == 'text') {
        return token.text.split("");
    }
    return [token.raw];
};

const renderItemTk = async (showMdText, tktxt, obj) => {
    if (typeof tktxt == 'string') {
        showMdText += tktxt;
        obj.mdhtml = marked.parse(showMdText);
        await sleep(120);
    } else {
        for (let m = 0; m < tktxt.itemtks.length; m++) {
            const item = tktxt.itemtks[m];
            if(typeof item != 'string'){
                tktxt.itemtks[m] = "";
                showMdText = await renderItemTk(showMdText, item, obj);
            }
            let nmd = showMdText + tktxt.pre + tktxt.itemtks.slice(0, m + 1).join("") + tktxt.hz;
            obj.mdhtml = marked.parse(nmd);
            if (m === tktxt.itemtks.length - 1) {
                showMdText = nmd;
            }
            await sleep(120);
        }
    }
    return showMdText;
};

export default {
	components: { AiHoverBtnCard2 },
	props: {
		itemData: {
			type: Object,
			default: null
		},
	},
	computed: {
	},
	data() {
		return {
			
			timer: null,
			currentTop: 0,
			left: 0,
			top: 0,

			oldScrollTop: 0,  //记录上一次滚动结束后的滚动距离
			scrollTop: 0,     // 记录当前的滚动距离


			dragging: false,
			mouseX: 0,				// 鼠标 X
			mouseY: 0,				// 鼠标 Y
			initialX: 0,
			initialY: 0,
			offsetX: 0,
			offsetY: 0,

			
			

			isShow: false,


			rawContent: '',
			displayedContent: '',
			interval: null,
			index: 1,

			mdhtml: '',

			isUnfold: true,

			isScrollBottom: true,

			isLoading: false,


			clientWidth: 0, // 页面宽度
			clientHeight: 0, // 页面高度
			itemWidth: 100, // 整个内容宽度
			itemHeight: 100, // 整个内容高度
			horizontalSpace: 20, // 水平顶部和底部最小间距
			verticalSpace: 20, // 垂直顶部和底部最小间距
			toastStr: null,
			isShowQrCode: false,
			qrCodeIsLoading: false,
			/**
			 index: 角标
			 type:  样式
			 	start				顶部起始卡片
				analysis			分析 - 用户点击分析、帮我解读
				aiContent			AI分析的内容
			 title: 标题
			 requestParamText：请求文本（猜你想问是问题一整句话）
			 content: AI内容字符串
			*/
			msgArr:[],

			shareTitle: '清雷AI助手',
			shareSubTitle: '点击查看AI解读',
			aiIsRequest: false,
			source: null,
			eventId: null,

			searchText: null,
			isEditing: false,

			sessionId: null
		};
	},
	created() {
	},
	mounted() {
		this.$nextTick(() => {
			this.elementAddObserver();

			this.msgArr = [
				{
					"index": 0,
					"type": 'start',
				},
				{
					"index": 1,
					"type": 'analysis',
					"title": '帮我解读“' + this.$props.itemData.bedName + '”' + this.$props.itemData.paramDate + '的睡眠报告',
				},
				{
					"index": 2,
					"type": 'aiContent',
					"title": 'Hi～，我是清雷AI助手，以下是“' + this.$props.itemData.bedName + '”' + this.$props.itemData.paramDate + '睡眠报告的解读内容： ',
					"requestParamText": '帮我解读“' + this.$props.itemData.bedName + '”的睡眠报告',
					"data": this.$props.itemData,
					"text": this.$props.itemData.bedName
				}
			]
			this.aiIsRequest = true;
		})		
	},
	methods: {
		// 打字完成的回调用
		typewritingFinish() {

		},
		requestFinish() {
			this.aiIsRequest = false;
		},
		changeShareTitle(text) {
			this.shareTitle = text;
		},
		changeShareSubTitle(text) {
			this.shareSubTitle = text;
		},
		// 修改每条消息对象的内容
		changeMsgArr(subItem, subIndex) {
			let tempMsgArr = JSON.parse(JSON.stringify(this.msgArr))
			tempMsgArr[subIndex]['content'] = subItem.content;
			this.msgArr = tempMsgArr;
		},
		// 点击事件 - AI分析、帮我解读
		clickAiAnalysis(item) {
			// 判断 AI 是否处于请求中
			if (!this.aiIsRequest) {
				this.aiIsRequest = true;
				// 
				if (item) {
					this.msgArr.push({
						"index": this.msgArr.length,
						"type": 'analysis',
						"title": item
					});
					this.msgArr.push({
						"index": this.msgArr.length,
						"type": 'aiContent',
						"title": item,
						"requestParamText": item,
						"text": item
					});
					this.$nextTick(() => {
						let element = document.getElementById("contentScrollId");
						element.scrollTop = element.scrollHeight
					});
				} else {
					this.msgArr.push({
						"index": this.msgArr.length,
						"type": 'analysis',
						"title": '帮我解读“清雷科技1号楼-3层-303-***”的睡眠报告'
					});
					this.msgArr.push({
						"index": this.msgArr.length,
						"type": 'aiContent',
						"title": 'Hi～，我是清雷AI助手，以下是“清雷科技1号楼-3层-303-***”报告的解读内容： ',
						"requestParamText": '帮我解读“清雷科技1号楼-3层-303-***”的睡眠报告'
					});
				}
			} else {
				this.$message.warning('AI正在分析中，请稍侯...');
			}
		},
		// 点击了折叠按钮
		clickUnflod() {
			this.isUnfold = !this.isUnfold;
		},
		// 点击AI展示事件
		clickShow() {
			if (!this.dragging) {
				this.itemWidth = 500;
				this.itemHeight = 758;
				this.isShow = true;
			}
			this.optimizedLocation();
		},
		// 关闭AI窗口事件
		clickCloseAi() {
			this.itemWidth = 100;
			this.itemHeight = 100;
			this.isShow = false;
			this.optimizedLocation();
		},
		// 监听鼠标移入窗口滑动区域
		mouseenter() {
			this.isScrollBottom = false;
		},
		// 监听鼠标移出窗口滑动区域
		mouseleave() {
			this.isScrollBottom = true;
		},
		// 对元素添加监听
		elementAddObserver() {
			// 创建tca元素的监听
			const obs1 = new MutationObserver((els)=>{
				let element = document.getElementById("contentScrollId");
				if (this.isScrollBottom) {
					element.scrollTop = element.scrollHeight
				}
			})
			obs1.observe(document.querySelector(".markdownContent"),{ 
				attributes: true, 
				childList: true, 
				subtree: true 
			})
		},
		async init() {
            const tokens = marked.lexer(markdown);
            console.log({ tokens });
            // this.mdhtml = marked.parse(tokens);
            let ptokens = [];
            for (let index = 0; index < tokens.length; index++) {
                const tk = tokens[index];
                ptokens = ptokens.concat(parseToken(tk));
            }
            console.log({
                ptokens
            });
            let i = 0;
            let showMdText = "";
            while (i < ptokens.length) {
                const tktxt = ptokens[i];
                showMdText = await renderItemTk(showMdText, tktxt, this);
                i++;	
            }
        },
		startTypewriterEffect() {
			if (this.interval) {
				clearInterval(this.interval);
			}
			this.interval = setInterval(() => {
				if (this.index < this.displayedContent.length) {
					this.index = this.index + 1;
					this.displayedContent = marked.parse(this.rawContent.substring(0, this.index));
				} else {
					clearInterval(this.interval);
				}
			}, 20); // 每100毫秒添加一个字符
		},
		handleScroll() {
			window.addEventListener('scroll', () => {
				// this.scrollTop = window.scrollY;
			})
		},
		copyTextRemoveMarkdown(markdownString) {
			const html = marked(markdownString); // 使用marked转换Markdown到HTML
			let text = html.replace(/<\/?[^>]+(>|$)/g, ''); // 使用正则表达式去掉HTML标记

			let textarea = document.createElement("textarea");
			textarea.value = text;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
			
			this.toastStr = '复制成功';
			setTimeout(() => {
				this.toastStr = null;
			}, 2000);
		},
		share() {
			this.$post(
				'/api/dean/ai/timelyCareElderShare',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');

						this.editAbnormalTimePopupOutBed = false;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);



			this.isShowQrCode = !this.isShowQrCode;
			this.$nextTick(function () {
				this.bindQRCode();
			});
		},
		bindQRCode: function () {
			this.qrCodeIsLoading = true;
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDetails, {
					text: 'http://localhost:8080/#/aiShare?jsonUrl=https%3A%2F%2Fql-hospital-test.oss-cn-beijing.aliyuncs.com%2Fpub%2Ffile%2Feeg%2FADT_R20240814153930.json',
					width: 160,
					height: 160,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.qrCodeIsLoading = false;
			}, 1000);

			// setTimeout(() => {
			// 	//判断二维码的距离实际顶部的距离
			// 	var shareP = document.getElementsByClassName("ant-popover")[0];
			// 	//console.log(shareP)
			// 	this.popoverTop =
			// 		parseInt(shareP.style.top.replace("px", "")) + this.scrollTop;
			// }, 0);
		},

		// 光标进入输入框
		handleFocus() {
			this.isEditing = true;
		},
		// 光标离开输入框
		handleBlur() {
			this.isEditing = false;
		},
		// 回车键点击事件 - 移除焦点
		removeFocus() {
			console.log('回车键点击事件 - 移除焦点')
		},

				adjustHeight() {
			const textarea = this.$refs.deepseekTextareaRef;
			textarea.style.height = 'auto';
			textarea.style.height = Math.min(textarea.scrollHeight, 343) + 'px';
        },
        sendMessage() {
			if (this.aiIsRequest && this.searchText && this.searchText.length > 0) {
				let tempStr = this.searchText.slice();
				this.searchText = null;
				this.$nextTick(() => {
					this.searchText = tempStr;
					this.$refs.deepseekTextareaRef.style.height = 'auto';
				});
				return
			}
			if (this.searchText == '') {
				this.searchText = null;
				this.$nextTick(() => {
					this.searchText = ''
					this.$refs.deepseekTextareaRef.style.height = 'auto';
				});
				return
			}
			if (this.searchText) {
				if (!this.searchText.trim()) return;
			} else {
				this.searchText = null;
				this.$nextTick(() => {
					this.searchText = ''
					this.$refs.deepseekTextareaRef.style.height = 'auto';
				});
				return
			}
			this.clickAiSearch();
			this.searchText = null;
			this.$nextTick(() => {
				this.searchText = ''
				this.$refs.deepseekTextareaRef.style.height = 'auto';
			});
        },
        newLine() {
			this.searchText += '\n';
			this.$nextTick(this.adjustHeight);
        },
        clearInput() {
			this.searchText = '';
			this.$nextTick(() => {
				this.$refs.deepseekTextareaRef.style.height = 'auto';
			});
        },



		// AI搜索
		clickAiSearch() {
			if (this.$refs.aiHoverBtnCard2RefReport && this.$refs.aiHoverBtnCard2RefReport.length > 0) {
				if (this.aiIsRequest) { // 停止请求
						this.$refs.aiHoverBtnCard2RefReport[this.$refs.aiHoverBtnCard2RefReport.length - 1].stopPrint()
						this.aiIsRequest = false;
						return
					}
					if (!this.searchText || this.searchText == '') {
						return
					}
					this.$refs.aiHoverBtnCard2RefReport[this.$refs.aiHoverBtnCard2RefReport.length - 1].aiSearch(this.searchText)
			}
			this.searchText = ''
		},
		clickCloseAiReport() {
			this.$store.commit("changeAiSingleReportData", null);
		}
	},
};
</script>
<style lang="scss" scoped>

.float-info{
	display: flex;
	flex-flow: column;
	justify-content: center;
	align-items: center;
	width: 900px;
	background: RGBA(241, 241, 242, 1);
	flex: 1;
	margin-top: 20px;
	margin-bottom: 20px;
	position: relative;
	border-radius: 20px;
	border: 2px solid #FFFFFF;
}

.copy_share {
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_6.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_8.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
}

.copy_share_copyBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_7.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_copyText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

.copy_share_shareBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_9.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

::v-deep .loadingContent {
	.el-loading-spinner {
		margin-top: -35px !important;
	}
}

.deepseek-textarea {
	flex: 1;
	margin-left: 15px;
	margin-right: 5px;
	min-height: 37px;
	max-height: 343px;
	border: none;
	background: transparent;
	resize: none;
	color: rgba(31, 38, 53, 1);
	font-size: 16px;
	font-family: PingFangSC, PingFang SC;
	line-height: 22px;
	outline: none;
	overflow-y: auto;
	caret-color: rgba(74, 124, 232, 1);
}

.deepseek-textarea::-webkit-scrollbar {
	display: none
}

.deepseek-textarea::placeholder {
	color: rgba(31, 38, 53, 0.2);;
}



</style>

<style>
.hiddenScrollbar::-webkit-scrollbar {
	display: none
}


/* 
.my-el-input-ai-report {
	margin-left: 8px;
	margin-right: 5px;
	.el-textarea__inner {
		background: #ffffff00 !important;
		border: none !important;
		outline: none !important;
		caret-color: #FFFFFF !important;
		box-shadow: none !important;
		font-size: 30px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #A0D0E7;
		line-height: 23px;
	}
	.el-textarea__inner:focus {
		border: none !important;
		outline: none !important;
		box-shadow: none !important;
	}
	
}

.my-el-input-ai-report .el-textarea__inner::placeholder {
	color: rgba(160, 208, 231, 0.2) !important;
}

.my-el-input-ai-report-editing {

} */

.search-btn {
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	margin-right: 10px;
	background: url('../../assets/icon_ai_search_icon_1.png') no-repeat no-repeat;
	background-size: contain;
	cursor: pointer;
	align-self: flex-end;
	margin-bottom: 1.5px;
}

.search-btn-can-search {
	background: url('../../assets/icon_ai_search_icon_2.png') no-repeat no-repeat;
	background-size: contain;
}

.search-btn-searching {
	background: url('../../assets/icon_ai_search_icon_3.png') no-repeat no-repeat;
	background-size: contain;
}

.my-el-input-ai-report-container {
	display: flex;
	align-items: center;
	flex: 1;
	margin-left: 16px;
	margin-right: 16px;
	padding-top: 8px;
	padding-bottom: 8px;
	background: rgba(255, 255, 255, 1);
	border-radius: 12px;
	border: 1px solid rgba(74, 124, 232, 0.30);
}

.my-el-input-ai-report-container-editing {
	border: 1px solid rgba(74, 124, 232, 1) !important;
}


</style>